export default "__VITE_ASSET__BvbHJ6En__"